export function doDrawImage2(ctx, src, srcleft, scrtop) {
  ctx.imageSmoothingEnabled = true;
  ctx.drawImage(src, srcleft, scrtop);
}
